import React from 'react';
import { IconButton, Button } from '@mui/material';
import { numberWithCommas } from 'utility';
import { Icons } from 'components';

const getPeriodText = (v) => {
  switch (v) {
    case 'سالانه':
      return 'سال';
    case 'ماهانه':
      return 'ماه';
    case 'هفتگی':
      return 'هفته';
    case 'روزانه':
      return 'روز';
    default:
      return v;
  }
};

let starStyle = 'primary';

const columns = (
  onClickDetail = () => { },
  onClickTransfer = () => { },
  putDefaultList = () => { },
  actionsList,
  classes,
  setShowDialog,
  setDataDialog,
  currencyText
) => [
    {
      title: 'ردیف',
      field: 'num',
      filtering: false,
      sorting: false,
      align: 'center',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
    },
    {
      title: 'شناسه',
      field: 'id',
      align: 'center',
      filtering: false,
    },
    {
      title: 'شروع',
      field: 'startDate', // 1384
      align: 'center',
      dir: 'ltr',
      filtering: false,
    },
    {
      title: 'انقضا',
      field: 'expireDate', // 1384
      align: 'center',
      dir: 'ltr',
      filtering: false,
    },
    {
      title: 'تخصیص‌دهنده',
      field: 'assignedFrom', // 1384
      align: 'center',
      filtering: false,
    },
    {
      title: `به میزان - ${currencyText}`,
      field: 'amount', // 1384
      align: 'center',
      filtering: false,
      render: (rc) => numberWithCommas(rc?.amount),
    },
    {
      title: `میزان مصرف - ${currencyText}`,
      field: 'usageAmount', // 1384
      align: 'center',
      filtering: false,
      render: (rc) => numberWithCommas(rc?.usageAmount),
    },
    {
      title: 'شارژ مجدد',
      field: 'recharge', // 1384
      align: 'center',
      filtering: false,
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
      render: (rc) =>
        rc?.recharge === 0
          ? '-'
          : `هر ${numberWithCommas(rc?.recharge)} ${getPeriodText(rc?.period)} یک‌بار`,
    },
    {
      title: 'وضعیت',
      field: 'status', // 1384
      align: 'center',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
      filtering: false,
    },
    {
      title: 'گزارش‌گیری',
      field: 'export', // 13
      filtering: false,
      align: 'center',
      sorting: false,
      render: (rd) => (
        <Button
          onClick={(e) => {
            onClickDetail(rd.delegationId);
            e.stopPropagation();
          }}
        >
          نمایش گزارش
        </Button>
      ),
    },
    ...(actionsList['transferAccountDelegationBtn'] ? [{
      title: 'انتقال اعتبار',
      field: 'transfer',
      filtering: false,
      align: 'center',
      sorting: false,
      render: (rd) => (
        <Button
          onClick={(e) => {
            onClickTransfer(rd);
            e.stopPropagation();
          }}
        >
          انتقال به سایرین
        </Button>
      ),
    }] : []),

    ...(actionsList['defaultAccountDelegationBtn'] ? [{
      title: '',
      filtering: false,
      align: 'center',
      sorting: false,
      render: (rd) => (
        <IconButton
          onClick={(e) => {
            if (!rd?.default) {
              putDefaultList(rd?.delegationId);
            } else {
            }
            e.stopPropagation();
          }}
          size="large">
          <Icons icon='startEmpty' color={!rd?.default ? starStyle : 'secondary'} size='20' />
        </IconButton>
      ),
    }] : []),
    ...((actionsList['detailAccountDelegationBtn']) ? [{
      title: 'عملیات',
      field: 'operationSmall',
      filtering: false,
      sorting: false,
      align: 'right',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
      render: (rowData) => (
        <Button startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />} variant="contained" className={classes.expandBtn}
          onClick={() => {
            setShowDialog(true);
            setDataDialog(rowData)
          }}
        >
          جزئیات
        </Button>
      ),
    }] : []),


  ];

const columnsId = {
  invoiceId: '1349',
  tax: '1444',
  invoiceStatus: '1352',
  guildName: '1353',
  decreased: '1354',
  hasMultiInvoice: '1384',
};

const orderingIndexes = [
  null,
  'زمان شروع',
  'زمان انقضا',
  'نام و نام خانوادگی',
  'میزان',
  'استفاده شده',
  'تعداد شارژ مجدد',
  'وضعیت',
  null,
  null,
];

const generateData = (rows, query) => {
  return rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      id: row.cols[0],
      startDate: row.cols[11],
      expireDate: row.cols[12],
      assignedFrom: row.cols[7],
      amount: row.cols[3],
      usageAmount: row.cols[4],
      recharge: row.cols[13],
      period: row.cols[14],
      status: row.cols[2],
      export: row.cols[1],
      details: row.cols[1],
      delegationId: row.cols[0],
      default: row.cols[16],
    };
  });
};

export { columns, columnsId, generateData, orderingIndexes };
